export default {
  title: 'Bedrijfsgegevens',
  form: {},
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    success: 'Uw gegevens zijn succesvol opgeslagen.',
  },
};
